import { Trans } from 'react-i18next'
import { appConfig } from '@/shared/config/app-config'
import { buildExternalUrl } from '@/shared/lib/external-url'

interface ContactSupportFooterProps {
  onContactSupport: () => void
  contactSupportLabel: string
  primaryAction?: {
    label: string
    onClick: () => void
  }
  className?: string
}

// Shared footer for membership/cancel-flow redesign screens. Pill buttons +
// minimalist Terms/Privacy line. Optional `primaryAction` renders a filled
// green button above the outlined Contact support (Figma footer variant B).
export function ContactSupportFooter({
  onContactSupport,
  contactSupportLabel,
  primaryAction,
  className = '',
}: ContactSupportFooterProps) {
  return (
    <div
      className={`flex w-full flex-col gap-2 border-t border-app-grey-200 bg-white px-6 pt-4 pb-2 ${className}`.trim()}
    >
      {primaryAction && (
        <button
          type="button"
          onClick={primaryAction.onClick}
          className="flex h-[49px] w-full cursor-pointer items-center justify-center rounded-[100px] bg-app-primary-600 font-inter text-[18px] font-semibold leading-[22px] tracking-[-0.36px] text-white transition-colors hover:bg-app-primary-700"
        >
          {primaryAction.label}
        </button>
      )}
      <button
        type="button"
        onClick={onContactSupport}
        className="flex h-[50px] w-full cursor-pointer items-center justify-center rounded-[100px] border border-app-primary-600 bg-white font-inter text-[18px] font-semibold leading-[22px] tracking-[-0.36px] text-app-primary-600 transition-colors hover:bg-app-primary-600/5"
      >
        {contactSupportLabel}
      </button>
      <p className="pt-1 text-center font-inter text-[12px] leading-4 tracking-[-0.24px] text-app-grey-600">
        <Trans
          i18nKey="unsubscription_membershipInfo_termsAndPolicy_web"
          components={{
            termsOfUseLink: (
              // biome-ignore lint/a11y/useAnchorContent: Trans injects text children from translation
              <a
                href={buildExternalUrl(
                  `${appConfig.siteUrl}/en/terms-of-use-and-service`,
                )}
                target="_blank"
                rel="noreferrer"
                className="text-app-grey-600 hover:underline"
              />
            ),
            privacyPolicyLink: (
              // biome-ignore lint/a11y/useAnchorContent: Trans injects text children from translation
              <a
                href={buildExternalUrl(
                  `${appConfig.siteUrl}/en/privacy-policy`,
                )}
                target="_blank"
                rel="noreferrer"
                className="text-app-grey-600 hover:underline"
              />
            ),
          }}
        />
      </p>
    </div>
  )
}
